/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailsvatidinvalid4Inputs */

const en_companydetailsvatidinvalid4 = /** @type {(inputs: Companydetailsvatidinvalid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The VAT number starts with the country code, e.g. ATU12345678.`)
};

const de_companydetailsvatidinvalid4 = /** @type {(inputs: Companydetailsvatidinvalid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die UID beginnt mit dem Länderkürzel, z. B. ATU12345678.`)
};

/**
* | output |
* | --- |
* | "The VAT number starts with the country code, e.g. ATU12345678." |
*
* @param {Companydetailsvatidinvalid4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailsvatidinvalid4 = /** @type {((inputs?: Companydetailsvatidinvalid4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailsvatidinvalid4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailsvatidinvalid4(inputs)
	return de_companydetailsvatidinvalid4(inputs)
});
export { companydetailsvatidinvalid4 as "companyDetailsVatIdInvalid" }